import moment from "moment";

export const formatTimeDataToUtcOffset = (time: string | Date | undefined) => {
  return moment(time, "HH:mm").add(moment().utcOffset(), "minutes").toDate();
};
